module.exports = __webpack_public_path__ + "img/NA.c5e062fc.svg";